module.exports = __webpack_public_path__ + "static/img/logo.12a8670.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.jpg
// module id = 20
// module chunks = 0